import { render, staticRenderFns } from "./swiper-pagination-primary.vue?vue&type=template&id=43c7d66c&scoped=true&"
import script from "./swiper-pagination-primary.vue?vue&type=script&lang=js&"
export * from "./swiper-pagination-primary.vue?vue&type=script&lang=js&"
import style0 from "./swiper-pagination-primary.vue?vue&type=style&index=0&id=43c7d66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c7d66c",
  null
  
)

export default component.exports